@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (dataSource.data.length === 0 && !loading) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No transaction requests found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (dataSource.data.length > 0 && !loading) {
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="transaction-requests-table">
      <!-- Request ID Column -->
      <ng-container matColumnDef="tx_request_id">
        <th mat-header-cell *matHeaderCellDef>Request ID</th>
        <td mat-cell *matCellDef="let request">{{ request.tx_request_id }}</td>
      </ng-container>
      <!-- Created At Column -->
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">Request Date</th> <!-- @product specified header -->
        <td mat-cell *matCellDef="let request">{{ formatDate(request.created_at) }}</td>
      </ng-container>
      <!-- Buyer Company Column -->
      <ng-container matColumnDef="buyer_company">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th> <!-- @product specified header -->
        <td mat-cell *matCellDef="let request">{{ request.buyer_company }}</td>
      </ng-container>
      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let request">{{ request.amount_label }}</td>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let request">
          <span class="status-badge" [class]="'status-' + request.statusProductFormat.toLowerCase()">
            {{ request.statusProductFormat }}
          </span>
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let request">
          <button mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()"
            [attr.aria-label]="'Actions for request ' + request.id">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #actionsMenu="matMenu">
            <button mat-menu-item color="primary" (click)="openCancelRequestDialog(request)" class="action-button" [disabled]="request.statusProductFormat !== 'Pending'">
              <mat-icon>cancel</mat-icon>
              Cancel Request
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="transaction-request-row"></tr>
    </table>
  </div>
}
